module.exports = __webpack_public_path__ + "img/forestry.55b416da.jpg";